import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import UserMembership from '@/model/dataLayer/api/MembershipSystem/UserMembership'
import AwardManagement from '@/model/dataLayer/api/MembershipSystem/AwardManagement'

const path = 'membership/award/'

const entity = {
  progress: {
    displayName: '积分'
  },
  awardTypeId: {
    displayName: '奖励类型',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await AwardManagement.getList(true) },
        itemText: 'description',
        itemValue: 'id'
      }
    }
  },
  status: {
    displayName: 'Status'
  },
  userId: {
    displayName: '用户',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await UserMembership.getList(true) },
        itemText: 'username',
        itemValue: 'userId'
      }
    }
  }
}

const config = {
  load: async function (filter) {
    const res = (await hillo.get(cloudV2Url + path + 'progress/blId/' + GlobalConfig.blId)).map(it => {
      return it
    })
    return res
  },
  add: async function (item) {
    return (await hillo.jsonPost(cloudV2Url + path + item.membershipLevelId + '/benefits', {
      ...item
    })).content
  },
  edit: async function (item) {
    return (await hillo.jsonPost(cloudV2Url + path + item.membershipLevelId + '/benefits/' + item.id, {
      ...item
    })).content
  },
  remove: async function (id) {
    console.log(id, 'id')
    // const levelId = ''
    // return (await hillo.jsonPost(cloudV2Url + path + '/' + levelId + '/benefits/' + id, {
    // }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)
